import React, { FunctionComponent } from "react";

import { Criteria } from "../../Accessories/Filters/Criteria/Criteria";
import { FiltersPanel } from "../../FiltersSidebar/FiltersPanel";
import {
  FiltersSidebar,
  useFiltersState,
} from "../../FiltersSidebar/FiltersSidebar";
import { Season } from "./Season/Season";

type PackageFiltersProps = {
  className?: string;
  isLoading: boolean;
};

export const PackageFilters: FunctionComponent<PackageFiltersProps> = ({
  className,
  isLoading,
}) => {
  const [, { hide }] = useFiltersState();
  return (
    <FiltersSidebar className={className}>
      <FiltersPanel loading={isLoading} onClose={hide}>
        <Criteria />
        <Season />
      </FiltersPanel>
    </FiltersSidebar>
  );
};
